import React from "react";
import PropTypes from "prop-types";

const Skeleton = ({ width, height, radius }) => (
  <div
    className="rd--skeleton"
    style={{ width, height, borderRadius: radius }}
  />
);

Skeleton.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  radius: PropTypes.string.isRequired
};

Skeleton.defaultProps = {
  width: "100px",
  height: "20px",
  radius: "4px"
};

export default Skeleton;
